<app-loader [isLoading]="isLoading"></app-loader>
<div *ngIf="!isLoading">
    <div class="orders-container pt-5" *ngIf="orderStatusData">
        <!-- HEADER -->
        <div class="header">
            <div>
                <h2 class="title">Order #{{ orderStatusData?.order_id }}</h2>
                <p class="sub">Order Placed on
                    <span class="text1"> {{ orderStatusData?.created_at | date:'dd MMM yyyy, hh:mm a' }}</span>
                </p>
                <p class="sub" *ngIf="orderStatusData?.status==='delivered'">Delivered on
                    <span class="text2">{{ orderStatusData?.updated_at | date:'dd MMM yyyy, hh:mm a'}}</span>
                </p>
                <!-- <p class="sub" *ngIf="orderStatusData?.status==='Return_requested'">Return Request on
                    <span class="text2">{{ orderStatusData?.requested_at | date:'dd MMM yyyy, hh:mm a'}}</span>
                </p> -->

                <!--Return message-->
                <p class="expected-delevery-text" *ngIf="orderStatusData?.status!=='delivered' && orderStatusData?.status !== 'cancelled' 
                    && orderStatusData?.status !== 'Return_Requested' && orderStatusData?.status !== 'Partially_Returned'
                    && orderStatusData?.status !== 'Fully_Returned' && orderStatusData?.status !== 'Replace_Requested'
                    && orderStatusData?.status !== 'Partially_Replaced'&& orderStatusData?.status !== 'Fully_Replaced'
                    && orderStatusData?.status !== 'Replacement_Shipped' && orderStatusData?.status !== 'Return_Approved'
                    && orderStatusData?.status !== 'Refund_Processing' && orderStatusData?.status !== 'Replace_Approved'
                     && orderStatusData?.status !== 'Picked_Up'
                    ">
                    <span>👉</span>
                    {{ getExpectedDeliveryMessage(orderStatusData?.created_at) }}
                </p>

                <!-- Cancelled -->
                <p class="cancel-order-text" *ngIf="orderStatusData?.status === 'cancelled'">
                    ❌ Your order has been cancelled
                </p>
                <!-- <p class="cancel-order-text" *ngIf="orderStatusData?.status === 'Return_Requested'">
                    Return request submitted. Waiting for admin approval
                </p> -->
                <div class="order-status-message" [ngClass]="getStatusClass(orderStatusData.status)">
                    {{ getStatusMessage(orderStatusData.status) }}
                </div>
            </div>

            <div class="status-badge" [ngClass]="statusClass(orderStatusData?.status)">
                <span class="dot"></span>
                {{ getOrderStatusText(orderStatusData) }}
            </div>
        </div>

        <!-- STEPPER -->
        <div class="card">
            <div class="order-stepper" [class.vertical]="isMobile">
                <div class="step" *ngFor="let s of steps; let i = index" [class.completed]="i < currentIndex"
                    [class.active]="i === currentIndex">
                    <div class="left">
                        <div class="circle">
                            <span class="icon"> <mat-icon>{{ s.icon }}</mat-icon></span>
                        </div>

                        <div class="line" *ngIf="i !== steps.length - 1"></div>
                    </div>

                    <div class="right">
                        <div class="label">{{ s.label }}</div>
                        <div class="label-des">{{ s.description }}</div>
                        <div class="step-indicator" *ngIf="i === currentIndex">
                            <div class="active-pulse"></div>
                            <span>Current Step</span>
                        </div>

                    </div>

                </div>

            </div>
        </div>

        <!-- ITEMS + SUMMARY GRID -->
        <div class="grid">
            <!-- ITEMS -->
            <div class="card">
                <h3 class="section-title">Item Ordered</h3>
                <div class="item" *ngFor="let item of orderStatusData?.items">
                    <!-- product image -->
                    <img class="item-img" [src]="getProductImage(item)" alt="product" />
                    <div class="item-info">
                        <div class="item-name">{{ item?.product_name | titlecase}}</div>
                        <div class="item-meta">Qty: {{ item?.quantity }}</div>
                        <div class="item-meta">Color: {{ item?.color | titlecase }}</div>
                        <div class="item-meta" *ngIf="item?.size">{{ getVariantLabel(item?.size) }}: {{ item?.size }}
                        </div>
                        <div class="item-meta">
                            Category: <span class="seller">{{ item?.sub_category | titlecase }}</span>
                        </div>
                        <div class="mt-2" *ngIf="canReturn() && orderStatusData?.status === 'delivered'">
                            <mat-checkbox [checked]="isSelected(item)" (change)="toggleItem(item)"
                                [disabled]="orderStatusData?.status !== 'delivered'">
                            </mat-checkbox>
                            <span class="return-checkbox-title">Return/Replace</span>
                        </div>
                    </div>
                    <div class="item-price">
                        ₹{{ item?.price }}
                    </div>

                </div>
                <div class="mt-2">
                    <button mat-stroked-button class="small-btn btn primary"
                        *ngIf="orderStatusData?.status === 'delivered'" (click)="openReturnDialog()"
                        [disabled]="!canReturn() || selectedItems.length === 0">Return Now</button>
                </div>
                <small class="danger-return" *ngIf="canReturn() && orderStatusData?.status === 'delivered'">
                    Returns and replacements are accepted within 24 hours after delivery only.
                </small>
                <div class="return-order-text" *ngIf="!canReturn() && orderStatusData?.status === 'delivered'">
                    Return period is over. You can raise return request within 24 hours from delivery date.
                </div>
            </div>
            <!-- SUMMARY -->
            <div class="card">
                <h3 class="section-title">Price Summary</h3>

                <div class="summary-row">
                    <span>Total Amount</span>
                    <span>₹{{ orderStatusData?.total_amount }}</span>
                </div>

                <div class="summary-row">
                    <span>Payment Method</span>
                    <span>{{ orderStatusData?.payment_method | uppercase }}</span>
                </div>

                <div class="summary-row">
                    <span>Order Source</span>
                    <span>{{ orderStatusData?.order_source | titlecase }}</span>
                </div>

                <div class="divider"></div>

                <div class="summary-row total">
                    <span>Grand Total</span>
                    <span>₹{{ orderStatusData?.total_amount }}</span>
                </div>

                <div class="btn-row">
                    <button mat-raised-button class="btn outline" *ngIf="orderStatusData?.status !== 'delivered' && orderStatusData?.status !== 'cancelled' && orderStatusData?.status !== 'out_for_delivery' 
                        && orderStatusData?.status!=='Return_Requested' && orderStatusData?.status!=='Partially_Returned' && orderStatusData?.status!=='Fully_Returned'
                        && orderStatusData?.status!=='Replace_Requested'  && orderStatusData?.status!=='Partially_Replaced'  && orderStatusData?.status!=='Fully_Replaced' 
                        && orderStatusData?.status!=='Return_Approved' && orderStatusData?.status!=='Replace_Approved' && orderStatusData?.status!=='Refund_Processing'
                        && orderStatusData?.status!=='Replacement_Shipped' && orderStatusData?.status!=='Picked_Up'
                        " (click)="cancelOrder()">
                        Cancel Order
                    </button>
                    <!-- <button mat-raised-button class="btn outline"
                        *ngIf="orderStatusData?.status === 'delivered' || orderStatusData?.status === 'cancelled'"
                        (click)="reOrder()">
                        Reorder
                    </button> -->
                </div>

            </div>

        </div>

        <!-- DELIVERY INFO -->
        <div class="card">
            <h3 class="section-title">Delivery Information</h3>

            <div class="delivery-grid">

                <!-- Address -->
                <div class="delivery-box">
                    <div class="delivery-title">Deliver To</div>

                    <div class="delivery-text">
                        {{ orderStatusData?.delivery_address?.name | titlecase }}
                    </div>

                    <div class="delivery-text">
                        {{ orderStatusData?.delivery_address?.address | titlecase }}
                    </div>

                    <div class="delivery-text">
                        {{ orderStatusData?.delivery_address?.mobile }}
                    </div>

                    <div class="delivery-text">
                        {{ orderStatusData?.delivery_address?.email }}
                    </div>
                </div>

                <!-- Payment -->
                <div class="delivery-box">
                    <div class="delivery-title">Payment</div>

                    <div class="delivery-text">
                        {{ orderStatusData?.payment_method | uppercase }}
                    </div>

                    <div class="delivery-text">
                        Status: <b>{{ orderStatusData?.status==='out_for_delivery'?'Out for
                            Delivery':orderStatusData?.status==='Return_requested'?'Return requested' :
                            orderStatusData?.status | titlecase }}</b>
                    </div>

                    <div class="support-links">
                        <div class="invoice-actions">
                            <button type="button" class="invoice-btn" (click)="showInvoice()" aria-label="View invoice">
                                <mat-icon>visibility</mat-icon>
                                <span>View Bill</span>
                            </button>
                            <button type="button" class="invoice-btn download" (click)="downloadInvoice()" aria-label="Download invoice">
                                <mat-icon>download</mat-icon>
                                <span>Download</span>
                            </button>
                        </div>
                     <a href="javascript:void(0)" (click)="contactEmail()">Contact Support : info@ruralx.in</a>
                    </div>
                </div>

            </div>
        </div>

    </div>
</div>